const messageManageRoute = [
  // 系统消息
  {
    path: "/system",
    name: "System",
    component: () => import("@/views/messageManage/systemMessage/index.vue"),
    meta: {
      activeName: "System",
    },
  },
  // 项目消息
  {
    path: "/projectmsg",
    name: "ProjectMsg",
    component: () => import("@/views/messageManage/projectMessage/index.vue"),
    redirect: "/projectmsg/groupchat",
    children: [
      {
        path: "groupchat",
        name: "GroupChat",
        component: () =>
          import("@/views/messageManage/projectMessage/groupChat.vue"),
        meta: {
          activeName: "ProjectMsg",
        },
      },
      {
        path: "modifymsg",
        name: "ModifyMsg",
        component: () =>
          import("@/views/messageManage/projectMessage/modifyMsg.vue"),
        meta: {
          activeName: "ProjectMsg",
        },
      },
    ],
    meta: {
      activeName: "ProjectMsg",
    },
  },
];

export default messageManageRoute;
